// Site-wide disruption banner (output via the website_banner() template tag) - rendered
// client-side on purpose, because the site runs behind a page cache: schedule and URL
// targeting must always be evaluated against the real visitor, never baked into the cached page HTML.
document.addEventListener('DOMContentLoaded', function () {

  var root = document.getElementById('site-banner-root');
  if (!root || !window.siteBannerData) return;

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + date.toUTCString() + '; path=/; SameSite=Lax';
  }

  function normalizePath(path) {
    return path.length > 1 && path.slice(-1) === '/' ? path.slice(0, -1) : path;
  }

  function urlMatchesRule(rule) {
    var pathname = window.location.pathname;
    var value = rule.value || '';

    switch (rule.type) {
      case 'path_exact':
        return value !== '' && normalizePath(pathname) === normalizePath(value);
      case 'path_contains':
        return value !== '' && pathname.indexOf(value) !== -1;
      case 'path_starts_with':
        return value !== '' && pathname.indexOf(value) === 0;
      case 'path_ends_with':
        return value !== '' && pathname.slice(-value.length) === value;
      case 'query_param':
        var params = new URLSearchParams(window.location.search);
        if (value === '' || !params.has(value)) return false;
        return rule.param_value ? params.get(value) === rule.param_value : true;
      case 'host_exact':
        return value !== '' && window.location.hostname === value;
      case 'host_contains':
        return value !== '' && window.location.hostname.indexOf(value) !== -1;
      case 'url_exact':
        return value !== '' && normalizePath(window.location.href) === normalizePath(value);
      case 'url_contains':
        return value !== '' && window.location.href.indexOf(value) !== -1;
      case 'url_starts_with':
        return value !== '' && window.location.href.indexOf(value) === 0;
      case 'url_ends_with':
        return value !== '' && window.location.href.slice(-value.length) === value;
      default:
        return false;
    }
  }

  function ruleSetMatches(ruleSet) {
    if (!ruleSet || ruleSet.scope === 'all') return true;
    if (ruleSet.scope !== 'specific' || !ruleSet.rules.length) return false;

    return ruleSet.logic === 'AND'
      ? ruleSet.rules.every(urlMatchesRule)
      : ruleSet.rules.some(urlMatchesRule);
  }

  function isBannerVisibleHere(banner) {
    if (!ruleSetMatches(banner.include)) return false;
    if (banner.exclude && banner.exclude.scope === 'specific' && ruleSetMatches(banner.exclude)) return false;
    return true;
  }

  function isDismissed(banner) {
    var dismissedAt = getCookie('site_banner_dismissed_' + banner.id);
    if (!dismissedAt) return false;
    if (banner.dismiss.reshowBehavior === 'never') return true;

    var dismissedTimestamp = parseInt(dismissedAt, 10);
    if (!dismissedTimestamp) return false;

    var reshowSeconds = banner.dismiss.reshowBehavior === 'days'
      ? banner.dismiss.reshowAfter * 86400
      : banner.dismiss.reshowAfter * 3600;

    return (Math.floor(Date.now() / 1000) - dismissedTimestamp) < reshowSeconds;
  }

  function dismissBanner(banner) {
    setCookie('site_banner_dismissed_' + banner.id, Math.floor(Date.now() / 1000), 365);
  }

  function renderBanner(banner) {
    root.style.setProperty('--site-banner-bg', banner.design.backgroundColor);
    root.style.setProperty('--site-banner-text', banner.design.textColor);

    var bannerEl = document.createElement('div');
    bannerEl.className = 'site-banner';

    var innerEl = document.createElement('div');
    innerEl.className = 'site-banner__inner';
    bannerEl.appendChild(innerEl);

    var contentEl = document.createElement('div');
    contentEl.className = 'site-banner__content';
    contentEl.innerHTML = banner.content;
    innerEl.appendChild(contentEl);

    if (banner.dismiss.allowed) {
      var closeButton = document.createElement('button');
      closeButton.type = 'button';
      closeButton.className = 'site-banner__close';
      closeButton.setAttribute('aria-label', 'Sulje');
      closeButton.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"/></svg>';
      closeButton.addEventListener('click', function () {
        dismissBanner(banner);
        root.innerHTML = '';
        document.dispatchEvent(new CustomEvent('site-banner:hidden', { detail: { id: banner.id } }));
      });
      innerEl.appendChild(closeButton);
    }

    root.innerHTML = '';
    root.appendChild(bannerEl);

    document.dispatchEvent(new CustomEvent('site-banner:shown', { detail: { id: banner.id, element: bannerEl } }));
  }

  fetch(window.siteBannerData.restUrl, {
    headers: { 'X-WP-Nonce': window.siteBannerData.nonce }
  })
    .then(function (response) { return response.ok ? response.json() : []; })
    .then(function (banners) {
      for (var i = 0; i < banners.length; i++) {
        var banner = banners[i];
        if (isBannerVisibleHere(banner) && !isDismissed(banner)) {
          renderBanner(banner);
          break;
        }
      }
    })
    .catch(function (err) {
      console.error('Site banner fetch error:', err);
    });

});
